export default "__VITE_ASSET__DXtOmFui__"